module.exports = __webpack_public_path__ + "img/LINE_LOGO.eb349a3a.svg";